import Index from '@/vues/favorites/index.vue';

export default [
  {
    path: '/favorites',
    name: 'Favorite Index',
    component: Index
  }
];
